import React from 'react';
import Icon from './Icon';

export default class IconArrowDownCircle extends Icon {

    renderIcon() {
        const color = this.props.color ? this.props.color : (this.state.hover ? '#ec6b05' : '#A6ACAF')
        return (
            <svg width={this.getSize()} height={this.getSize() / 2} viewBox="0 0 24 12">
                <g transform="translate(0,-12)">
                    <path
                        d="m8.9198 21.085 0.20008 0.20164a0.33174 0.33174 0 0 0 0.23688 0.09745 0.33226 0.33226 0 0 0 0.23637-0.09745l2.2844-2.2844 2.287 2.287a0.33174 0.33174 0 0 0 0.23688 0.09745 0.33174 0.33174 0 0 0 0.23636-0.09745l0.20008-0.2006a0.33485 0.33485 0 0 0 0-0.47273l-2.7229-2.7327a0.34211 0.34211 0 0 0-0.23688-0.1073h-1e-3a0.34211 0.34211 0 0 0-0.23692 0.1073l-2.7203 2.7255a0.33796 0.33796 0 0 0 1e-7 0.47636z"
                        fill="#101720" strokeWidth=".51835"/>
                </g>

                <g transform="translate(0 -302.65)">
                    <path
                        d="m12.051 302.9c-6.5234 0-11.819 5.246-11.928 11.752h0.37109c0.10835-6.3053 5.2342-11.381 11.557-11.381 6.3224 0 11.45 5.0756 11.559 11.381h0.37109c-0.10859-6.5059-5.4063-11.752-11.93-11.752z"
                        fill="none"/>
                </g>
            </svg>
        )
    }
}